import { repository } from "repositories";
import { SWRResponse, Tag, TODO_Transfer } from "shared/types";
import useSWRImmutable from "swr/immutable";

const TAG_TYPE = "divination";

export const useDivinationTagList = (): SWRResponse<{
  divinationTags: Tag[];
}> => {
  const repo = repository.tag.getList({ metaDescriptionType: TAG_TYPE });

  const { data, error, mutate } = useSWRImmutable(
    [repo.path, TAG_TYPE],
    repo.data,
    { fallbackData: { tags: [] } }
  );

  return {
    divinationTags: data?.tags,
    isLoading: !data && !error,
    isError: !!error,
    mutate: mutate as TODO_Transfer,
  };
};
